module.exports = __webpack_public_path__ + "3e329be405fcc5f83bc541c878d31242.pdf";